import ko from "knockout";
import _ from "lodash";
import Promise from "bluebird";

ko.asyncComputed = function (evaluator, errorCallback, owner) {
    const result = ko.observable();
    let currentPromise;
    result.inProgress = ko.observable(false); // Track whether we're waiting for a result

    const computed = ko.computed(function () {
        // Abort any in-flight evaluation to ensure we only notify with the latest value
        if (currentPromise) {
            currentPromise.cancel();
        }

        const evaluatorResult = evaluator.call(owner);
        // Cope with both asynchronous and synchronous values
        if (evaluatorResult && typeof evaluatorResult.done == "function") {
            // Async
            result.inProgress(true);
            currentPromise = evaluatorResult;
            evaluatorResult
                .then(function (data) {
                    result.inProgress(false);
                    result(data);
                })
                //cancellation should not change inProgress state or call errorCallback
                .catch(Promise.CancellationError, _.noop)
                .catch(function () {
                    result.inProgress(false);
                    if (errorCallback) {
                        errorCallback();
                    }
                })
                .finally(function () {
                    currentPromise = null;
                });
        } else {
            // Sync
            result(evaluatorResult);
        }
    });

    //Set dispose on the returned observable to dispose of the
    result.dispose = computed.dispose.bind(computed);

    return result;
};
